import html2pdf from "html2pdf.js";

const PDFExporter =()=>{

        const exportToPDF = (targetId, title) => {
            const element = document.getElementById(targetId);
            const options = {
                filename: title,
                html2canvas: { scale: 2 }, 
                jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            };
            html2pdf().from(element).set(options).save();
        };

        return{
            exportToPDF
        }
}

export default PDFExporter